module.exports = (function() { return this["wp"]["element"]; }());